// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

<template>
  <div class="global-footer">
  </div>
</template>

<script>
import { InfoCircleOutlined, CustomerServiceOutlined, PhoneOutlined } from '@ant-design/icons-vue'

export default {
  name: 'KingHostGlobalFooter',
  components: {
    InfoCircleOutlined,
    CustomerServiceOutlined,
    PhoneOutlined
  },
  methods: {
    showVersionUpdate () {
      return this.$store.getters.latestVersion &&
        this.$store.getters.latestVersion.version &&
        this.$store.getters.latestVersion.version !== '' &&
        this.$store.getters.latestVersion.version !== this.$store.getters.features.cloudstackversion &&
        !this.$store.getters.features.cloudstackversion.includes(this.$store.getters.latestVersion.version)
    }
  },
  mounted () {
    console.log('🎨 [KINGHOST] GlobalFooter customizado carregado - links Apache removidos')
  }
}
</script>

<style scoped>
.global-footer {
  background: transparent;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;

  .line {
    margin: 8px 0;

    a {
      color: #782dc9;
      text-decoration: none;

      &:hover {
        color: #40a9ff;
        text-decoration: underline;
      }
    }
  }
}
</style>
